// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"HomePage_HomePage__3vnaQ","header":"HomePage_header__2jwGJ","other":"HomePage_other__AAZ0m","main":"HomePage_main__3eUxl"};